const oldTableHeaders = viewIsPaid => {
  let header = [
    {
      text: 'STT',
      value: 'stt',
      align: 'center',
      sortable: false,
      show: true,
      width: '4%'
    },
    {
      text: 'Học sinh',
      value: 'name',
      align: 'left',
      sortable: false,
      show: true,
      width: '24%'
    },
    {
      text: 'Ngày sinh',
      value: 'dob',
      align: 'left',
      sortable: false,
      show: true,
      width: '12%'
    },
    {
      text: 'Lớp',
      value: 'currentClass',
      align: 'left',
      sortable: false,
      show: true,
      width: '8%'
    },
    {
      text: 'Tổng số tiền thu',
      value: 'moneyTotal',
      align: 'right',
      sortable: false,
      show: true,
      width: '10%'
    },
    {
      text: 'Thao tác',
      value: 'action',
      align: 'center',
      sortable: false,
      show: true,
      width: '8%'
    }
  ]
  if (viewIsPaid) {
    header.splice(5, 0, {
      text: 'Đã thu',
      value: 'isPaid',
      align: 'center',
      sortable: false,
      show: true,
      width: '6%'
    })
  }
  return header
}

export function originHeaders(viewIsPaid, isOld = false) {
  if (isOld) return oldTableHeaders(viewIsPaid)
  let header = [
    {
      text: 'STT',
      value: 'stt',
      align: 'center',
      width: '4%'
    },
    {
      text: 'Học sinh',
      value: 'name',
      width: '24%'
    },
    {
      text: 'Ngày sinh',
      value: 'dob',
      width: '12%'
    },
    {
      text: 'Lớp',
      value: 'currentClass',
      width: '8%'
    },
    {
      text: 'Tổng số tiền thu',
      value: 'moneyTotal',
      width: '40%'
    },
    {
      text: 'Số tiền đã nộp',
      value: 'amountPaid',
      width: '10%'
    },
    {
      text: 'Còn nợ',
      value: 'amountDebt',
      width: '10%'
    },
    {
      text: 'Thao tác',
      value: 'actions',
      align: 'center',
      width: '8%'
    }
  ]
  return header
}

export function neoOriginHeaders(isTeacher = false) {
  let header = [
    { text: 'STT', value: 'stt', align: 'center', width: '4%' },
    { text: 'Học sinh', value: 'name', width: '24%' },
    { text: 'Ngày sinh', value: 'dob', width: '12%' },
    { text: 'Lớp', value: 'currentClass', width: '8%' },
    { text: 'Tổng số tiền thu', value: 'moneyTotal', width: '40%' },
    { text: 'Thao tác', value: 'actions', align: 'center', width: '8%' }
  ]
  if (!isTeacher) {
    header.splice(
      5,
      0,
      ...[
        { text: 'Số tiền đã nộp', value: 'amountPaid', width: '10%' },
        // { text: 'Còn nợ', value: 'amountDebt', width: '10%' }
      ]
    )
  }
  return header
}
export const headerExcel = [
  {
    text: 'Tên học sinh',
    value: 'name'
  },
  {
    text: 'Mã số',
    value: 'code'
  },
  {
    text: 'Ngày sinh',
    value: 'dob'
  },
  {
    text: 'Giới tính',
    value: 'gender'
  },
  {
    text: 'Lớp',
    value: 'class'
  },
  {
    text: 'Trạng thái',
    value: 'status'
  },
  {
    text: 'Ghi chú',
    value: 'notes'
  },
  {
    text: '"Học phí" phải thu',
    value: 'cen.totalAmount'
  },
  {
    text: '"Thu hộ/chi hộ" phải thu',
    value: 'decen.totalAmount'
  },
  {
    text: 'Tổng số tiền phải thu',
    value: 'totalMoney'
  },
  {
    text: '"Học phí" đã thu',
    value: 'cen.amountPaid'
  },
  {
    text: '"Thu hộ/chi hộ" đã thu',
    value: 'decen.amountPaid'
  },
  {
    text: 'Tổng số tiền đã thu',
    value: 'totalMoneyPaid'
  },
  {
    text: '"Học phí" còn nợ',
    value: 'cen.amountDebt'
  },
  {
    text: '"Thu hộ/chi hộ" còn nợ',
    value: 'decen.amountDebt'
  },
  {
    text: 'Tổng số tiền còn nợ',
    value: 'totalMoneyDebt'
  },
  { text: 'Tài khoản định danh', value: 'customerId' },
  { text: 'Thời gian ghi nhận giao dịch (Học phí)', value: 'transTime' },
  { text: 'Mã tham chiếu (Học phí)', value: 'bankTransId' }
]
